import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Map as MapIcon, ListChecks, LogOut } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { dateLabel } from "@/lib/status";

const NAV = [
  { to: "/worker/map", label: "Beach Map", icon: MapIcon, testid: "worker-nav-map" },
  { to: "/worker/today", label: "My Today", icon: ListChecks, testid: "worker-nav-today" },
];

export default function WorkerLayout() {
  const { user, logout } = useAuth();
  const [info, setInfo] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/app-info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const outletCtx = React.useMemo(() => ({ info }), [info]);

  return (
    <div className="min-h-screen bg-background pb-24">
      <header className="sticky top-0 z-40 border-b border-stone-200 bg-white/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <div className="flex items-center gap-2.5">
            <img src="/plaza-mark.png" alt="Plaza" className="h-11 w-11 object-contain" />
            <div className="leading-tight">
              <p className="font-heading text-base font-extrabold tracking-tight" data-testid="worker-beach-name">
                {info?.beach_name || "Beach"}
              </p>
              <p className="text-xs text-stone-500" data-testid="worker-current-date">
                {dateLabel(info?.today)}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right leading-tight">
              <p className="text-sm font-bold" data-testid="worker-name">{user?.name}</p>
              <p className="text-xs text-stone-500">Worker</p>
            </div>
            <button
              data-testid="worker-logout-btn"
              onClick={async () => {
                await logout();
                navigate("/login");
              }}
              className="flex h-10 w-10 items-center justify-center rounded-xl border border-stone-200 text-stone-600 transition hover:bg-stone-100"
            >
              <LogOut className="h-5 w-5" strokeWidth={2.4} />
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-2xl px-4 pt-5">
        <Outlet context={outletCtx} />
      </main>

      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-stone-200 bg-white/90 backdrop-blur-xl">
        <div className="mx-auto grid max-w-2xl grid-cols-2">
          {NAV.map((n) => {
            const active = location.pathname === n.to;
            const Icon = n.icon;
            return (
              <button
                key={n.to}
                data-testid={n.testid}
                onClick={() => navigate(n.to)}
                className={`flex flex-col items-center gap-1 py-3 text-sm font-bold transition ${
                  active ? "text-primary" : "text-stone-400"
                }`}
              >
                <Icon className="h-6 w-6" strokeWidth={2.5} />
                {n.label}
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
